<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-3">
          <strong class="card-title mb-3">Relative Strength Measure</strong>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-2">
          <download :tableId="'relative-strength-measure'" :fileName="'relative-strength-measure'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-9 br">
          <filtersMrkt
            ref="mrkFilt"
            :dDate="ddate"
            @filter="filtData"
            @filterDate="filtDate"
            :filterOptions="filterOptions"
          ></filtersMrkt>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            >
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selRangeFilter" @change="filterRangeData($event)">
              <option
                v-for="(d, index) in mcOptions"
                v-bind:key="d.id+index"
                :value="index"
              >{{d.value}}</option>
            </select>
          </div>
        </div>
      </div>
      <hr>
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <select class="form-control" name="raw-data" v-model="mrktFilter" @change="getRawData">
              <option
                v-for="(d, index) in mrktFilterList"
                v-bind:key="d.id+index"
                :value="d.id"
              >{{d.value}}</option>
            </select>
          </div>
        </div>
      </div>
      <hr>
      <div class="row mb5">
        <div class="col-md-3" style="float: left;">
          <strong>Avg NC from OA</strong>
          : {{getFixed(avg_net_cash_from_operating_activities)}}
        </div>
        <div class="col-md-3" style="float: left;">
          <strong>Avg Sale</strong>
          : {{getFixed(avg_sale)}}
        </div>
        <div class="col-md-3" style="float: left;">
          <strong>Avg Traded Vol</strong>
          : {{getFixed(avg_traded_volume)}}
        </div>
      </div>
      <hr>
      <div class="table-responsive app" v-dragscroll="true">
        <table id="relative-strength-measure" class="table table-bordered fonts11 app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th
                @click="sortColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="'field'+field+index+key"
              >
                {{field.name}}
                <i
                  class="fa fa-caret-down"
                  v-if="(field.sort_order == 1 || field.sort_order == 0)"
                ></i>
                <i
                  class="fa fa-caret-up"
                  v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rawData" v-bind:key="'row'+row+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="'td'+field.title+index">
                <span v-if="field.isLink">
                  <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                </span>
                <span v-else>{{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}}</span>
                <!-- {{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}} -->
              </td>
            </tr>
          </tbody>
        </table>
        <div class="alert alert-danger" role="alert"  v-if="rawData.length===0">No data found!</div>
      </div>
      <!-- <div class="row" v-else>
        <div class="col-md-12">
          <div class="alert alert-danger" role="alert">No data found!</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  props: ["company"],
  mixins: [commonMixins],
  created() {
    this.getRawData();
  },
  data() {
    return {
      ddate: "", //new Date().setDate(new Date().getDate() - 1),
      tableFields: [
        {
          title: "co_code",
          name: "Company Code",
          isNumeric: false,
          sort_order: "",
          isLink: 0
        },
        {
          title: "companyname",
          name: "Company",
          isNumeric: false,
          sort_order: "",
          isLink: 1
        },
        {
          title: "marketCapitalization_latest",
          name: "Market Cap (Latest)",
          isNumeric: true,
          sort_order: "",
          isLink: 0
        },
        {
          title: "net_cash_from_operating_activities",
          name: "NC from Operating Activities",
          isNumeric: true,
          sort_order: "",
          isLink: 0
        },
        {
          title: "sales",
          name: "Sales",
          isNumeric: true,
          sort_order: "",
          isLink: 0
        },
        {
          title: "traded_volume",
          name: "Traded Volume",
          isNumeric: true,
          sort_order: "",
          isLink: 0
        }
      ],
      rawDataApi: "relativeStrengthMeasure",
      rawData: [],
      avg_net_cash_from_operating_activities: "",
      avg_sale: "",
      avg_traded_volume: "",
      searchData: [],
      searchText: "",
      mrktFilterList: [
        { id: "f1", value: "Filter 1" },
        { id: "f2", value: "Filter 2" },
        { id: "f3", value: "Filter 3" },
        { id: "f", value: "Final Data" }
      ],
      mrktFilter: "f",
      minRange: "",
      maxRange: "",
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        },
        {
          id: "marketCapitalization_latest",
          value: "Market Cap (Latest)",
          isNumeric: true,
          sort_order: ""
        },
        {
          id: "net_cash_from_operating_activities",
          value: "NC from Operating Activities",
          isNumeric: true,
          sort_order: ""
        },
        {
          id: "sales",
          value: "Sales ",
          isNumeric: true,
          sort_order: ""
        },
        {
          id: "traded_volume",
          value: "Traded Volume ",
          isNumeric: true,
          sort_order: ""
        }
      ],
      selFilter: "",
      selRangeFilter: 0,
      mcOptions: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ]
    };
  },
  methods: {
    getRawData() {
      this.isLoading = true;
      this.rawData = {};
      let myself = this;
      http.post(
        this.rawDataApi,
        {
          name: this.mrktFilter,
          my_date: myself.ddate != "" ? myself.getDate(myself.ddate) : ""
        },
        (error, response) => {
          if (response.length > 0) {
            this.avg_net_cash_from_operating_activities =
              response[0].avg_net_cash_from_operating_activities;
            this.avg_sale = response[0].avg_sale;
            this.avg_traded_volume = response[0].avg_traded_volume;
            myself.rawData = response[0].finalData;
            myself.searchData = response[0].finalData;
            if (response[0].finalData.length > 0) {
              console.log("Set Date", new Date(response[0].finalData[0].date));
              myself.ddate = new Date(response[0].finalData[0].date);
            }
          }
        }
      );
    },
    filterRangeData(event) {
      this.clearData();
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rawData = this.searchData;
        return this.rawData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rawData = this.searchData.filter(rd => {
          // console.log(rd, this.selRangeFilter);
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange) &&
              parseInt(rd["marketCapitalization_latest"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange)
              );
            }
            if (this.maxRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) <=
                parseInt(maxRange)
              );
            }
          }
        });
      }
      setTimeout(() => {
        this.sortColumn(this.tableFields[3], 3);
      });
    },
    filteredList(e) {
      this.selRangeFilter = 0;
      this.selFilter = "";
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.companyname
              ? rd.companyname
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    filterData() {
      this.clearData();
      if (this.selFilter !== "") {
        if (this.minRange == "" && this.maxRange == "") {
          this.rawData = this.searchData;
          return this.rawData;
        } else {
          this.rawData = this.searchData.filter(rd => {
            console.log(rd, this.selFilter);
            if (this.minRange != "" && this.maxRange != "") {
              return (
                parseInt(rd[this.selFilter]) >= parseInt(this.minRange) &&
                parseInt(rd[this.selFilter]) <= parseInt(this.maxRange)
              );
            } else {
              if (this.minRange != "") {
                return parseInt(rd[this.selFilter]) >= parseInt(this.minRange);
              }
              if (this.maxRange != "") {
                return parseInt(rd[this.selFilter]) <= parseInt(this.maxRange);
              }
            }
          });
        }
      }
    },
    //Get data Datewise
    filtDate(obj) {
      console.log("FilterDATE", obj, JSON.stringify(obj));
      this.ddate = new Date(obj.durDate);
      this.getRawData();
    },
    filtData(obj) {
      console.log("Filter", obj, JSON.stringify(obj));
      // this.ddate = new Date(obj.durDate);
      this.minRange = obj.min;
      this.maxRange = obj.max;
      this.selFilter = obj.selField;
      this.filterData();
    },
    clearData() {
      this.selRangeFilter = 0;
      // this.selFilter = "";
      this.searchText = "";
      this.rawData = this.searchData;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/relativeStrengthMeasure.vue